function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uADF8\\uB8F9 15514",
  fill: "#a8afb9"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 45813",
  d: "M10.505 5.409a4.01 4.01 0 104.01 4.01 4.016 4.016 0 00-4.01-4.01z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uD328\\uC2A4 45814",
  d: "M20.316 2.917h-4.3L13.363 0H7.637L4.981 2.917H.684L0 3.51V17h21V3.51l-.684-.594zm-9.811 11.871a5.394 5.394 0 115.3-5.393 5.349 5.349 0 01-5.3 5.393z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uADF8\\uB8F9 15515"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "\\uD569\\uCE58\\uAE30 11",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "#a8afb9"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.498 21.5a1.25 1.25 0 01-1.248-1.248V17.75h-2.501a1.25 1.25 0 010-2.5h2.501v-2.502a1.25 1.25 0 012.501 0v2.502h2.501a1.25 1.25 0 010 2.5h-2.501v2.502c0 .687-.563 1.248-1.253 1.248z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.498 21a.75.75 0 00.753-.748V17.25h3.001c.41 0 .748-.338.748-.748a.753.753 0 00-.748-.752h-3.001v-3.002a.753.753 0 00-.753-.748.752.752 0 00-.748.748v3.002h-3.001a.75.75 0 000 1.5h3.001v3.002a.75.75 0 00.748.748m0 1a1.75 1.75 0 01-1.748-1.748V18.25h-2.001a1.75 1.75 0 010-3.5h2.001v-2.002a1.75 1.75 0 013.501 0v2.002h2.001a1.75 1.75 0 010 3.5h-2.001v2.002c0 .965-.786 1.748-1.753 1.748z",
  fill: "#f5f6f8"
})));

var SvgPlaygroundImageSelect = function SvgPlaygroundImageSelect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaygroundImageSelect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/playground-image-select.b7f2e258.svg";
export { ForwardRef as ReactComponent };